import { IonSkeletonText } from '@ionic/react';
import { memo } from 'react';

const Skeleton = memo(({ className }: { className?: string }) => {
  return <IonSkeletonText animated className={className} />;
});

export default Skeleton;
